import { useRef } from 'react';
import Card from './Card';
import './NemPanel.css';

export default function NemPanel({
  discardCount = 1,
  pendingCards = [],  // driven by reducer state (nemPendingDiscardIds)
  onConfirmNem,
  onPendingAdd,    // dispatch NEM_PENDING_ADD
  onPendingRemove, // dispatch NEM_PENDING_REMOVE
}) {
  const confirmingRef = useRef(false);

  const handleDrop = (e) => {
    e.preventDefault();
    try {
      const card = JSON.parse(e.dataTransfer.getData('text/plain'));
      if (pendingCards.some(c => c.id === card.id)) return;
      if (pendingCards.length >= discardCount) return;
      onPendingAdd?.(card.id);
    } catch { /* ignore */ }
  };

  const handleRemoveFromDiscard = (card) => {
    onPendingRemove?.(card.id);
  };

  const handleConfirm = () => {
    if (confirmingRef.current) return;
    confirmingRef.current = true;
    onConfirmNem(pendingCards.map(c => c.id), pendingCards);
  };

  const canConfirm = pendingCards.length === discardCount;

  return (
    <div className="nem-panel">
      <span className="nem-panel__label">Discard Zone ({pendingCards.length}/{discardCount})</span>
      <div
        className={`nem-panel__zone ${canConfirm ? 'nem-panel__zone--full' : ''}`}
        onDragOver={(e) => { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; }}
        onDrop={handleDrop}
      >
        {pendingCards.length === 0 && (
          <span className="nem-panel__hint">Tap or drag card here</span>
        )}
        {pendingCards.map(card => (
          <Card
            key={card.id}
            card={card}
            size="small"
            onTap={() => handleRemoveFromDiscard(card)}
          />
        ))}
      </div>
      {canConfirm && (
        <button className="nem-panel__confirm btn btn--primary" onClick={handleConfirm}>
          Confirm Nem
        </button>
      )}
    </div>
  );
}
